<template>
  <b-modal
    id="create-template-domain-modal"
    :title="$t('label.domain_template_add')"
    scrollable
    hide-footer>
    <b-form @submit.prevent="onSubmit">
      <b-form-group
        :label="$t('label.domain_name')"
        label-for="domain-name-input">
        <b-form-input
          id="domain-name-input"
          v-model="name"
          type="text"
          :disabled="loading"
          :placeholder="$t('label.domain_template_add_placeholder')"
          required>
        </b-form-input>
      </b-form-group>
      <div class="text-center">
        <b-button type="submit" variant="primary" :disabled="loading || patgames.length === 0">{{ $t('btn.new') }}</b-button>
      </div>

      <b-alert :show="error !== null" variant="danger" style="margin-top: 1rem">
        {{ error }}
      </b-alert>

      <div>Voici les domaines d'activités qui seront lié à ce template:</div>
      <b-table 
        :fields="fields"
        :items="activeDomains">

       <template #cell(patgames)="row">
        <b-form-select
          :options="unlinkedPatgames"
          value-field="act_id"
          text-field="act_label"
          @input="updatePatgamesDomain($event, row.item)">
          <template #first v-if="unlinkedPatgames.length !== 0">
            <b-form-select-option :value="-42">Ajouter tous</b-form-select-option>
          </template>
        </b-form-select>
        
        <b-button 
          v-for="module in patgames.filter(m => m.act_dac_id === row.item.dac_id)"
          :key="'module-' + module.act_id"
          size="sm"
          style="margin: 1px;"
          @click="removeModuleFromDomain(module)">
            {{ module.act_label }}
          </b-button>
        </template>

        </b-table>
    </b-form>
  </b-modal>
</template>

<script>
import { normalizeString } from '../misc/utils';

import { createTemplate } from '../services/establishment';

export default {
  props: {
    domains: {
      type: Array,
      default: () => [],
    },
    templates: {
      type: Array,
      default: () => [],
    },
    establishment: {
      type: Object,
      required: true,
    },
    patgames: {
      type: Array,
      default: () => [],
    }
  },
  data() {
    return {
      name: '',
      loading: false,
      error: null,
    };
  },
  computed: {
    fields() {
      return [
        {
          dac_label: {
            label: this.$t('label.domain_name'),
            sortable: true,
          }
        },
        {
          patgames: {
            label: 'Patgames à associer',
            sortable: false,
          }
        }
      ]
    },
    activeDomains() {
      return this.domains.filter(d => d.dac_is_enable)
    },
    unlinkedPatgames() {
      return this.patgames.filter(m => this.domains.find(d => d.dac_id === m.act_dac_id) === undefined).sort((a, b) => a.act_label.localeCompare(b.act_label))
    }
  },
  methods: {
    async show() {
      if (this.patgames.length === 0) {
        this.error = "Vous n'avez aucun jeu PATGames associé à l'établissement. Vous ne pouvez pas créer de template."
      } else {
        this.error = null;
      }
      this.loading = false;
      this.name = '';
      this.$bvModal.show("create-template-domain-modal")
    },
    hide() {
      this.$bvModal.hide("create-template-domain-modal")
    },
    updatePatgamesDomain(id, domain) {
      if (id === -42) {
        this.unlinkedPatgames.forEach(m => {
          m.act_dac_id = domain.dac_id;
        })
      }
      else {
        const activity = this.patgames.find(m => m.act_id === id);
        if (activity === undefined) return;
        activity.act_dac_id = domain.dac_id;
      }
      this.$forceUpdate();
    },
    removeModuleFromDomain(module) {
      module.act_dac_id = null;
      this.$forceUpdate();
    },
    async onSubmit() {
      if (this.patgames.length === 0) return;
      this.error = null;
      // Check if template domain already exists
      const normalizedName = normalizeString(this.name);
      const existingTemplate = this.templates.find(template => normalizeString(template?.label) === normalizedName);
      if (existingTemplate !== undefined) {
        this.error = `${this.$t("label.domain_template_already_exists")} : "${existingTemplate.label}"`;
        return
      }
      if (this.unlinkedPatgames.length !== 0) {
        this.error = 'Vous devez lier les activités PATGames au(x) domaine(s) d\'activités';
        return
      }
      this.loading = true;
      const template = await createTemplate(
        this.name,
        this.activeDomains.map((d) => ({
          id: d.dac_id,
          data: d.dac_data,
          label: d.dac_label,
          patgames: this.patgames.filter(m => m.act_dac_id === d.dac_id).map(m => (m.act_id))
        })));
      if (template === undefined) {
        this.error = this.$t('error.general');
        this.loading = false;
        return
      
      }
      this.$emit('onCreated', template);
      this.showToast('success', this.$t('label.domain_template_added_success'), this.$t('label.domain_template_add'))
      this.hide();
      this.loading = false;
    }
  }
}
</script>